import { startAuthentication, startRegistration } from "@simplewebauthn/browser";
import { api } from "./api.js";

/**
 * Register a passkey on this device. First device is open; a new device that isn't
 * signed in must pass a one-time enrollment code minted from a signed-in device.
 */
export async function registerPasskey(code?: string): Promise<boolean> {
  const options = await api.registerOptions(code);
  // @simplewebauthn/browser handles the navigator.credentials dance + Face/Touch ID.
  const attResp = await startRegistration({ optionsJSON: options as never });
  const { verified } = await api.registerVerify(attResp);
  return verified;
}

/** Authenticate with an existing passkey (one Face ID / Touch ID tap). */
export async function loginWithPasskey(): Promise<boolean> {
  const options = await api.loginOptions();
  const authResp = await startAuthentication({ optionsJSON: options as never });
  const { verified } = await api.loginVerify(authResp);
  return verified;
}
